module.exports = {

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var component = event.data.component;
			component.performAndStoreAction(
				'openModalInCharge',
				component.prepareAction('openHtmlEditor')
			);
		}
	},

	hooks: {
		async onDecision($element, options){
			const modal = (((this.actions.openModalInCharge || {}).source || {}).load || {}).component
			if(!modal){
				throw new ClientError('HTML_EDITOR_BUTTON_MISSING_MODAL')
			}

			if(options.decisionType !== 'submit') {
				return modal.hide()
			}

			let editor, parent
			modal.find('base_form_fields_html-editor', c => editor = c)
			this.parent(c => parent = c)

			if(!editor){
				throw new ClientError('HTML_EDITOR_BUTTON_MISSING_EDITOR')
			}

			// set modified text in model
			const value = this.model.dataTEXT = editor.getEditorContent()
			// set modified text as preview in div
			this.$.find('.contentPreview').html(`${value.substring(0, 260).replace(/<[a-zA-Z\/][^>]*>/gi, '')} ...`)

			// hide modal
			await modal.hide()

			if(parent){
				await parent.trigger('onChildChanged', {
					fieldCode:  this.model.fieldCode,
					value,
				})
			}
		},
	}
}